class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class MessageCategoryRequestParamsDto {
  /** 消息分类编码 */
  categoryCode = "";

  /** 消息分类名称 */
  categoryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 默认渠道 */
  defaultChannel = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 消息类型 all:所有消息 broadcast:广播消息  p2p:点对点消息 */
  messageType = "";

  /** 命名空间 */
  namespaceCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageCategoryResponseDto {
  /** 消息分类编码 */
  categoryCode = "";

  /** 消息分类名称 */
  categoryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 默认渠道 */
  defaultChannel = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 消息类型 all:所有消息 broadcast:广播消息  p2p:点对点消息 */
  messageType = "";

  /** 命名空间 */
  namespaceCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageChannelRequestParamsDto {
  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间开始 */
  createTimeGe = "";

  /** 创建时间结束 */
  createTimeLe = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageChannelResponseDto {
  /** 渠道编号 */
  channelCode = "";

  /** 渠道名称 */
  channelName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageEventRequestParamsDto {
  /** 事件编号 */
  code = "";

  /** 内容模板 */
  contentTemplate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 事件名称 */
  name = "";

  /** 命名空间 */
  namespaceCode = "";

  /** 事件描述 */
  remark = "";

  /** 快照模板 */
  snapshotTemplate = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** url模板 */
  urlTemplate = "";
}

class MessageEventResponseDto {
  /** 事件编号 */
  code = "";

  /** 内容模板 */
  contentTemplate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 事件名称 */
  name = "";

  /** 命名空间 */
  namespaceCode = "";

  /** 事件描述 */
  remark = "";

  /** 快照模板 */
  snapshotTemplate = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** url模板 */
  urlTemplate = "";
}

class MessageMasterRequestDto {
  /** 消息类别编号 */
  categoryCode = "";

  /** 消息类别名称 */
  categoryName = "";

  /** 内容 */
  content = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 模板数据 */
  data = "";

  /** 删除标识 */
  deleted = undefined;

  /** 事件编码 */
  eventCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 命名空间编码 */
  namespaceCode = "";

  /** 源单据编号 */
  originRecordCode = "";

  /** 源单据状态 */
  originRecordStatus = "";

  /** 接收消息类型源编码 */
  receiveCode = "";

  /** 接收消息类型： 广播消息(组织架构:organization/群组:group/角色:role/部门:department/用户列表:userlist) 点对点消息（用户:user） */
  receiveType = "";

  /** 未读消息重推次数 */
  resendNumber = undefined;

  /** 消息通知渠道：ws：WebSocket dd:钉钉 mail:邮件 sms:短信 */
  sendChannel = "";

  /** 消息发送方式 timed:定时发送 	immediate:即时发送 */
  sendMethod = "";

  /** 定时发送时间：0为没有设置 时间戳：固定发送时间 */
  sendTime = undefined;

  /** 发送人 OR 事件触发人 */
  sender = "";

  /** 快照文本 */
  snapshot = "";

  /** 来源系统编号 */
  sourceSystem = "";

  /** 标题 */
  title = "";

  /** 消息类型 broadcast:广播消息  p2p:点对点消息 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 点击地址 */
  url = "";
}

class MessageMasterRequestParamsDto {
  /** 消息类别编号 */
  categoryCode = "";

  /** 消息类别名称 */
  categoryName = "";

  /** 内容 */
  content = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间开始 */
  createTimeGe = "";

  /** 创建时间结束 */
  createTimeLe = "";

  /** 模板数据 */
  data = "";

  /** 删除标识 */
  deleted = undefined;

  /** 事件编号 */
  eventCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 命名空间编码 */
  namespaceCode = "";

  /** 源单据编号 */
  originRecordCode = "";

  /** 源单据状态 */
  originRecordStatus = "";

  /** 是否已读 */
  readFlag = undefined;

  /** 接收消息类型源编码 */
  receiveCode = "";

  /** 接收消息类型： 广播消息(组织架构:organization/群组:group/角色:role/部门:department/用户列表:userlist) 点对点消息（用户:user） */
  receiveType = "";

  /** 未读消息重推次数 */
  resendNumber = undefined;

  /** 消息通知渠道：ws：WebSocket dd:钉钉 mail:邮件 sms:短信 */
  sendChannel = "";

  /** 消息发送方式 timed:定时发送 	immediate:即时发送 */
  sendMethod = "";

  /** 定时发送时间：0为没有设置 时间戳：固定发送时间 */
  sendTime = undefined;

  /** 发送时间开始 */
  sendTimeRealGe = "";

  /** 发送时间结束 */
  sendTimeRealLe = "";

  /** 发送人 OR 事件触发人 */
  sender = "";

  /** 快照文本 */
  snapshot = "";

  /** 来源系统编号 */
  sourceSystem = "";

  /** 标题 */
  title = "";

  /** 消息类型 broadcast:广播消息  p2p:点对点消息 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 点击地址 */
  url = "";

  /** 用户code */
  userCode = "";
}

class MessageMasterResponseDto {
  /** 消息类别编号 */
  categoryCode = "";

  /** 消息类别名称 */
  categoryName = "";

  /** 内容 */
  content = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 事件编码 */
  eventCode = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 命名空间编码 */
  namespaceCode = "";

  /** 源单据编号 */
  originRecordCode = "";

  /** 源单据状态 */
  originRecordStatus = "";

  /** 查阅人数 */
  readNum = undefined;

  /** 接收消息类型源编码 */
  receiveCode = "";

  /** 接收消息类型： 广播消息(组织架构:organization/群组:group/角色:role/部门:department/用户列表:userlist) 点对点消息（用户:user） */
  receiveType = "";

  /** 未读消息重推次数 */
  resendNumber = undefined;

  /** 消息通知渠道：ws：WebSocket dd:钉钉 mail:邮件 sms:短信 */
  sendChannel = "";

  /** 消息发送方式 timed:定时发送 	immediate:即时发送 */
  sendMethod = "";

  /** 定时发送时间：0为没有设置 时间戳：固定发送时间 */
  sendTime = undefined;

  /** 消息的发送时间 */
  sendTimeReal = "";

  /** 发送人 OR 事件触发人 */
  sender = "";

  /** 发送人数 */
  senderNum = undefined;

  /** 快照文本 */
  snapshotText = "";

  /** 来源系统编号 */
  sourceSystem = "";

  /** 标题 */
  title = "";

  /** 消息类型 broadcast:广播消息  p2p:点对点消息 */
  type = "";

  /** 未阅人数 */
  unreadNum = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 点击地址 */
  url = "";
}

class MessageMasterSendDto {
  /** 消息类别编号 */
  categoryCode = "";

  /** 消息类别名称 */
  categoryName = "";

  /** 内容 */
  content = "";

  /** 模板数据 */
  data = "";

  /** 事件编号 */
  eventCode = "";

  /** 命名空间编码 */
  namespaceCode = "";

  /** 接收消息类型源编码 */
  receiveCode = "";

  /** 接收消息类型： 广播消息(组织架构:organization/群组:group/角色:role/部门:department/用户列表:userlist) 点对点消息（用户:user） */
  receiveType = "";

  /** 未读消息重推次数 */
  resendNumber = undefined;

  /** 消息通知渠道：ws：WebSocket dd:钉钉 mail:邮件 sms:短信 */
  sendChannel = "";

  /** 消息发送方式 timed:定时发送 	immediate:即时发送 */
  sendMethod = "";

  /** 定时发送时间：0为没有设置 时间戳：固定发送时间 */
  sendTime = undefined;

  /** 发送人 OR 事件触发人 */
  sender = "";

  /** 快照文本 */
  snapshot = "";

  /** 来源系统编号 */
  sourceSystem = "";

  /** 标题 */
  title = "";

  /** 消息类型 broadcast:广播消息  p2p:点对点消息 */
  type = "";

  /** 点击地址 */
  url = "";
}

class MessageNamespaceRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 命名空间编号 */
  namespaceCode = "";

  /** 命名空间名称 */
  namespaceName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageNamespaceResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 命名空间编号 */
  namespaceCode = "";

  /** 命名空间名称 */
  namespaceName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class MessageNoticeUserRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 消息ID */
  messageId = undefined;

  /** 命名空间 */
  namespaceCode = "";

  /** 已读客户端 pc moblie */
  readClien = "";

  /** 是否已读 */
  readFlag = false;

  /** 已读时间 */
  readTime = "";

  /** 是否发送 */
  sendFlag = false;

  /** 发送次数 */
  sendNumber = undefined;

  /** 发送时间 */
  sendTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户编号 */
  userCode = "";
}

class MessageNoticeUserResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 消息ID */
  messageId = undefined;

  /** 命名空间 */
  namespaceCode = "";

  /** 已读客户端 pc moblie */
  readClien = "";

  /** 是否已读 */
  readFlag = false;

  /** 已读时间 */
  readTime = "";

  /** 是否发送 */
  sendFlag = false;

  /** 发送次数 */
  sendNumber = undefined;

  /** 发送时间 */
  sendTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 用户编号 */
  userCode = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

export const mns = {
  IPage,
  MessageCategoryRequestParamsDto,
  MessageCategoryResponseDto,
  MessageChannelRequestParamsDto,
  MessageChannelResponseDto,
  MessageEventRequestParamsDto,
  MessageEventResponseDto,
  MessageMasterRequestDto,
  MessageMasterRequestParamsDto,
  MessageMasterResponseDto,
  MessageMasterSendDto,
  MessageNamespaceRequestParamsDto,
  MessageNamespaceResponseDto,
  MessageNoticeUserRequestParamsDto,
  MessageNoticeUserResponseDto,
  Response,
  ResponseDto,
};
